import { render, staticRenderFns } from "./FormAccordion.vue?vue&type=template&id=76501dc6&"
import script from "./FormAccordion.vue?vue&type=script&lang=js&"
export * from "./FormAccordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports